<highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" style="width: 100%; padding-right:10px; display: block;">
</highcharts-chart>
